<template>
    <b-container>
        <h1>User Activity</h1>
        <hr>
        <b-row>
            <b-col cols="3">
                <b-form-group label="Select User:">
                    <b-form-select v-model="user_selected" :options="user_options"></b-form-select>
                </b-form-group>
                <b-form-group label="Select Activity Type:">
                    <b-form-select v-model="activity_type_selected" :options="activity_type_options"></b-form-select>
                </b-form-group>
                <b-form-group label="Activity Date:">
                    <DatePicker v-model="activity_date" date-id="activity_date" />
  
                </b-form-group>

                <b-form-group label="Select Actions:">

                    <b-form-checkbox-group v-model="actions_selected" :options="actions"
                        stacked></b-form-checkbox-group>
                </b-form-group>
                <b-form-group>
                    <b-button variant="primary" block @click="runReport()">Run Report</b-button>
                </b-form-group>
            </b-col>
            <b-col>
                <b-card v-if="results.length == 0">
                    No logs found
                </b-card>
                <div v-else>
                    <line-chart-generator :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId"
                        :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles"
                        :width="width" :height="height" />
                    <b-table striped hover :fields="fields" :items="results">
                        <template #cell(created_at)="data">
                            {{ data.value | fullDate }}
                        </template>
                        <template #cell(link)="data">
                            <b-link :to="data.value">
                                {{ data.item.title }}
                            </b-link>
                        </template>
                    </b-table>
                </div>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
import ReportDataService from '@/services/ReportDataService';
import UserDataService from '@/services/UserDataService';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import DatePicker from '@/components/DatePicker.vue';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
)


export default {
    name: 'LineChart',
    components: {
        LineChartGenerator,
        DatePicker
    },
    props: {
        chartId: {
            type: String,
            default: 'line-chart'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 250
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => { }
        },
        plugins: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            results: [],
            fields: ['name', 'action', 'link', 'created_at'],
            user_selected: 'all',
            user_options: [],
            activity_type_options: [
                { text: 'Any', value: 'any' },
                { text: 'Aspect', value: 'aspect' },
                { text: 'Attachment', value: 'attachment' },
                { text: 'Note', value: 'note' },
                { text: 'Task', value: 'task' },
                { text: 'Policy', value: 'policy' },
            ],
            activity_type_selected: 'any',
            activity_date: new Date().toLocaleDateString('en-US'),
            actions: [
                { text: 'Update', value: 'update' },
                { text: 'Delete', value: 'delete' },
                { text: 'Read', value: 'read' },
                { text: 'Create', value: 'create' },
            ],
            actions_selected: ['update', 'delete', 'read', 'create'],
            chartOptions: {

            },
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Read',
                        backgroundColor: '#0a58ca',
                        data: []
                    },
                    {
                        label: 'Create',
                        backgroundColor: '#198754',
                        data: []
                    },
                    {
                        label: 'Update',
                        backgroundColor: '#b02a37',
                        data: []
                    },
                    {
                        label: 'Delete',
                        backgroundColor: '#ffc720',
                        data: []
                    }
                ]
            }
        }
    },
    created() {

        UserDataService.getActiveUsers().then((res) => {

            // add All Users option then loop result
            this.user_options.push({ text: 'All Users', value: 'all' })

            // loop result and add to options
            res.data.forEach((user) => {
                this.user_options.push(user)
            })

            // Auto-run report after users are loaded
            this.runReport();
        })

    },
    methods: {
        runReport() {

            let date_report;
            try {
                date_report = new Date(this.activity_date).toISOString().slice(0, 10);
            } catch (e) {
                date_report = new Date().toISOString().slice(0, 10);
            }

            const actions = Array.isArray(this.actions_selected) ? this.actions_selected.join(',') : this.actions_selected;

            ReportDataService.getUserActivity(this.user_selected, this.activity_type_selected, actions, date_report).then((res) => {

                this.results = res.data.log.data;
                this.chartData.labels = res.data.categories;
                this.chartData.datasets[0].data = res.data.read;
                this.chartData.datasets[1].data = res.data.create;
                this.chartData.datasets[2].data = res.data.update;
                this.chartData.datasets[3].data = res.data.delete;
            })
        }
    }
}
</script>